module.exports = __webpack_public_path__ + "media/4x3/gf-38dfa23a.svg";